import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { tx as translateInterfaceText } from '@/utils/i18n';
import { normalizeText } from '@/utils/normalizeText';
import type { FlowListItem, FlowStatus } from '@/services/dynamicFlowsService';

export type StatusFilter = 'all' | FlowStatus;

export const STATUS_FILTERS: { value: StatusFilter; label: string }[] = [
  { value: 'all', get label() { return translateInterfaceText("Todos"); } },
  { value: 'published', get label() { return translateInterfaceText("Publicados"); } },
  { value: 'draft', get label() { return translateInterfaceText("Rascunhos"); } },
  { value: 'paused', get label() { return translateInterfaceText("Pausados"); } },
];

export function countByStatus(items: FlowListItem[]): Record<StatusFilter, number> {
  const counts: Record<StatusFilter, number> = { all: items.length, published: 0, draft: 0, paused: 0 };
  for (const item of items) counts[item.status] += 1;
  return counts;
}

// Busca pelo nome ignorando acentos e caixa, combinada com o filtro de status.
export function filterFlows(items: FlowListItem[], query: string, status: StatusFilter): FlowListItem[] {
  const term = normalizeText(query.trim());
  return items.filter(
    (item) =>
      (status === 'all' || item.status === status) && (!term || normalizeText(item.name).includes(term)),
  );
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatEditedAgo(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return translateInterfaceText("sem edição");
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return translateInterfaceText("sem edição");

  const diff = Math.max(0, now.getTime() - date.getTime());
  if (diff < MINUTE) return 'editado agora';
  if (diff < HOUR) return `editado há ${Math.floor(diff / MINUTE)} min`;
  if (diff < DAY) return `editado há ${Math.floor(diff / HOUR)} h`;
  if (diff < 2 * DAY) return 'editado ontem';
  if (diff < 7 * DAY) return `editado há ${Math.floor(diff / DAY)} dias`;
  if (diff < 30 * DAY) {
    const weeks = Math.floor(diff / (7 * DAY));
    return `editado há ${weeks} ${weeks === 1 ? 'semana' : 'semanas'}`;
  }
  return `editado em ${date.toLocaleDateString(getInterfaceLanguage())}`;
}

export function formatVideoCount(count: number): string {
  return `${count} ${count === 1 ? 'vídeo' : 'vídeos'}`;
}

// A exclusão só libera quando o nome digitado bate com o do fluxo (ignorando espaços nas pontas).
export function canConfirmDelete(typed: string, flowName: string): boolean {
  return typed.trim().length > 0 && typed.trim() === flowName.trim();
}
